const ChevronIcon = ({ className = "" }) => (
  <svg aria-hidden="true" className={className} fill="none" viewBox="0 0 20 20">
    <path
      d="M5.5 7.5 10 12l4.5-4.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    />
  </svg>
);

export default ChevronIcon;
